/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitBatchDownloadResult,
    PressKitBatchDownloadResultFromJSON,
    PressKitBatchDownloadResultFromJSONTyped,
    PressKitBatchDownloadResultToJSON,
} from './PressKitBatchDownloadResult';

/**
 * 
 * @export
 * @interface PostPressKitBatchDownloadResponse
 */
export interface PostPressKitBatchDownloadResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof PostPressKitBatchDownloadResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof PostPressKitBatchDownloadResponse
     */
    message: string;
    /**
     * 
     * @type {PressKitBatchDownloadResult}
     * @memberof PostPressKitBatchDownloadResponse
     */
    data: PressKitBatchDownloadResult;
}

export function PostPressKitBatchDownloadResponseFromJSON(json: any): PostPressKitBatchDownloadResponse {
    return PostPressKitBatchDownloadResponseFromJSONTyped(json, false);
}

export function PostPressKitBatchDownloadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressKitBatchDownloadResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressKitBatchDownloadResultFromJSON(json['data']),
    };
}

export function PostPressKitBatchDownloadResponseToJSON(value?: PostPressKitBatchDownloadResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressKitBatchDownloadResultToJSON(value.data),
    };
}

